import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=337c3fd4&scoped=true&"
import script from "./MyWallet.vue?vue&type=script&lang=js&"
export * from "./MyWallet.vue?vue&type=script&lang=js&"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=337c3fd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337c3fd4",
  null
  
)

export default component.exports